import {
  GetHistoricalSpendsRequest,
  GetHistoricalSpendsResponse,
} from "@mutiny-group/sbo-openapi-client";

import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";

type GetHistoricalSpendsV2Params = GetHistoricalSpendsRequest & {
  scenarioBuilderClient: ScenarioBuilderClient;
};
export const getHistoricalSpendsV2 = ({
  scenarioBuilderClient,
  ...filters
}: GetHistoricalSpendsV2Params): Promise<GetHistoricalSpendsResponse> => {
  return scenarioBuilderClient.spends.getHistoricalSpends(filters);
};
